module.exports = __webpack_public_path__ + "static/img/cMRId4.28aaaaf2.png";